<template>
<!-- ====================== 페이지내 내용 ====================== -->
    <div>
        <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >
        <v-toolbar-title >프로젝트 기간내 통계</v-toolbar-title>
        <v-spacer/>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="blue-grey lighten-2"
            small
            fab
            v-bind="attrs"
            v-on="on"
        >
            <v-icon 
            color= ""
            >mdi-information-variant</v-icon>
        </v-btn>
    </template>
    프로젝트별 통계 관련 설명
    </v-tooltip>
    </v-toolbar>
    <!-- ====================== 이쪽에 데이터테이블이 들어간다 ====================== -->
        <form
            class="pa-4">
            <v-row>
                <v-col cols="3">
                    <v-select
                    v-model="selectedProject"
                    :items="billingProjectList"
                    item-text="project_name"
                    item-value="package_name"
                    label="프로젝트 선택"
                    filled
                    outlined
                    dense
                    hide-details
                    ></v-select>
                </v-col>
                <v-col cols="2">
                </v-col>
                <v-col cols="3">
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date"
                            label="검색 시작일 선택"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            filled
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date"
                        no-title
                        scrollable
                        :max="date2"
                        @click:date="$refs.menu.save(date)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="3">
                    <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="date2"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date2"
                            label="검색 종료일 선택"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            filled
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date2"
                        no-title
                        scrollable
                        :max="today"
                        :min="date"
                        @click:date="$refs.menu2.save(date2)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="1">
                    <v-btn
                    class="mr-4"
                    color="blue"
                    @click="submit"
                    :disabled="tempInfo[0]?selectedProject?false:true:true"
                    block
                    >
                    검색
                    </v-btn>
                </v-col>
            </v-row>
        </form>
    </v-card>
        <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        color='#37474F'
        dark
        dense
    >
        <v-toolbar-title>총 합</v-toolbar-title>
        <v-spacer/>
    </v-toolbar>
    <div
    v-if="dataFlag == 'noRequest'"
    class="py-6"></div>
    <div
    v-if="dataFlag == 'underRequest'"
    class="d-flex justify-center pa-6" >
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
    </div>
    <div
    v-if="dataFlag == 'dataEx'"
    >
        <v-row>
            <v-col>
                <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>{{ androidTotalSumCost }}</v-list-item-title>
                    <v-list-item-subtitle>안드로이드 전체 과금금액</v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col>
                <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>{{ iosTotalSumCost }}</v-list-item-title>
                    <v-list-item-subtitle>ios 전체 과금금액</v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col>
                <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">{{ totalSumCost }}</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-bold">과금 합</v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col>
                <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>{{ androidTotalSumCount }}</v-list-item-title>
                    <v-list-item-subtitle>안드로이드 전체 과금건수</v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col>
                <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>{{ iosTotalSumCount }}</v-list-item-title>
                    <v-list-item-subtitle>ios 전체 과금건수</v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col>
                <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">{{ totalSumCount }}</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-bold">과금 건수 합</v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </v-col>
        </v-row>
    </div>
    </v-card>
        <div class="py-3"></div>
    <v-card
        class="mx-auto pb-1"
        max-width="90%"
    >
    <v-toolbar
        color='#37474F'
        dark
        dense
    >
        <v-toolbar-title>월별</v-toolbar-title>
        <v-switch
            v-model="switch1"
            :label="`건수`"
            hide-details
            class="ml-4"
        ></v-switch>
    </v-toolbar>
        <v-card class="mb-4 mt-4 mx-4" outlined>
            <v-card-title>금액</v-card-title>
            <v-card-subtitle >
                매 월간 결제금액
            </v-card-subtitle>
            <div
                v-if="dataFlag == 'underRequest'"
                class="d-flex justify-center pa-6" >
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
            </div>
            <div
            v-if="dataFlag == 'dataEx'" 
            class="mx-3 mb-2">
                <line-chart :chart-data="chartdataMonCost" :options="options" />
            </div>
        </v-card>
        <v-card class="mb-4 mt-4 mx-4" outlined v-if="switch1">
            <v-card-title>건수</v-card-title>
            <v-card-subtitle >
                매 월간 결제건수
            </v-card-subtitle>
            <div
                v-if="dataFlag == 'underRequest'"
                class="d-flex justify-center pa-6" >
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
            </div>
            <div
            v-if="dataFlag == 'dataEx'"
            class="mx-3 mb-2">
                <line-chart :chart-data="chartdataMonCount" :options="options3"/>
            </div>
        </v-card>
    </v-card>
        <div class="py-3"></div>
    <v-card
        class="mx-auto pb-1"
        max-width="90%"
    >
    <v-toolbar
        color='#37474F'
        dark
        dense
    >
        <v-toolbar-title>일별</v-toolbar-title>
        <v-switch
            v-model="switch2"
            :label="`건수`"
            hide-details
            class="ml-4"
        ></v-switch>
    </v-toolbar>
        <v-card class="mb-4 mt-4 mx-4" outlined>
            <v-card-title>금액</v-card-title>
            <v-card-subtitle >
                매 일간 결제금액
            </v-card-subtitle>
            <div
                v-if="dataFlag == 'underRequest'"
                class="d-flex justify-center pa-6" >
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
            </div>
            <div
            v-if="dataFlag == 'dataEx'"
            class="mx-3 mb-2">
                <line-chart :chart-data="chartdataDayCost" :options="options"/>
            </div>
        </v-card>
        <v-card class="mb-4 mt-4 mx-4" outlined v-if="switch2">
            <v-card-title>건수</v-card-title>
            <v-card-subtitle >
                매 일간 결제건수
            </v-card-subtitle>
            <div
                v-if="dataFlag == 'underRequest'"
                class="d-flex justify-center pa-6" >
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
            </div>
            <div
            v-if="dataFlag == 'dataEx'"
            class="mx-3 mb-2">
                <line-chart :chart-data="chartdataDayCount" :options="options3"/>
            </div>
        </v-card>
    </v-card>
        <div class="py-3"></div>
    <v-card
        class="mx-auto pb-4"
        max-width="90%"
    >
    <v-toolbar
        color='#37474F'
        dark
        dense
    >
        <v-toolbar-title>운영체제별</v-toolbar-title>
        <v-spacer/>
    </v-toolbar>
        <v-row>
            <v-col cols="8" >
                <v-card class="ml-4" outlined>
                    <v-card-title class="pb-0">안드로이드</v-card-title>
                    <v-row>
                        <v-col>
                            <v-card class="mx-4" outlined>
                                <v-card-title>언어</v-card-title>
                                <v-card-subtitle>
                                    안드로이드 운영체제의 언어권별 결제액
                                </v-card-subtitle>
                                <div
                                v-if="dataFlag == 'underRequest'"
                                class="d-flex justify-center pa-6" >
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                </div>
                                <div
                                    v-if="dataFlag == 'dataEx'"
                                >
                                    <v-row>
                                        <v-col>
                                            <v-list-item two-line>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ androidKorSumCost }}</v-list-item-title>
                                                <v-list-item-subtitle>한국</v-list-item-subtitle>
                                            </v-list-item-content>
                                            </v-list-item>
                                          
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card class="mx-4 mb-1" outlined>
                                    <v-card-title>과금분포</v-card-title>
                                    <v-card-subtitle class="">
                                        안드로이드 운영체제의 과금 분포
                                    </v-card-subtitle>
                                <div
                                v-if="dataFlag == 'underRequest'"
                                class="d-flex justify-center pa-6" >
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                </div>
                                <div
                                v-if="dataFlag == 'dataEx'"
                                class="mx-3 mb-3">
                                    <pie-chart :chartData="androidPie" :options="options2"></pie-chart>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
           <v-col cols="8" >
                <v-card class="ml-4" outlined>
                    <v-card-title class="pb-0">안드로이드</v-card-title>
                    <v-row>
                        <v-col>
                         
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card class="mx-4 mb-1" outlined>
                                    <v-card-title>과금분포 결제금액</v-card-title>
                                    <v-card-subtitle class="">
                                        안드로이드 운영체제의 과금 분포
                                    </v-card-subtitle>
                                <div
                                v-if="dataFlag == 'underRequest'"
                                class="d-flex justify-center pa-6" >
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                </div>
                                <div
                                v-if="dataFlag == 'dataEx'"
                                class="mx-4 mb-4">
                                    <pie-chart :chartData="androidPie_cost" :options="options4"></pie-chart>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
    <div class="py-3"></div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
import LineChart from './charts/LineChart'
import PieChart from './charts/PieChart.js'
export default {
    name: 'UserList',
    components: {
      LineChart,
      PieChart
    },
    data: () => ({
        //dataflag를 위한 내용
        request:false,
        //others
        androidTotalSumCost:'',
        iosTotalSumCost:'',
        totalSumCost:'',
        androidTotalSumCount:'',
        iosTotalSumCount:'',
        totalSumCount:'',
        androidKorSumCost:'',
        androidEnSumCost:'',
        androidChSumCost:'',
        androidTwSumCost:'',
        androidJpSumCost:'',
        iosKorSumCost:'',
        iosEnSumCost:'',
        iosChSumCost:'',
        iosTwSumCost:'',
        iosJpSumCost:'',
        //
        selectedProject:'',
        billingProjectList:[],
        projectBillingStatisticsData:{'day':[],'month':[],'others':[],'pieAndroid':[],'pieIos':[]},
        switch1:false,
        switch2:false,
        switch3:false,
        switch4:false,
        options: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
            callbacks: {
                    label: function(tooltipItem, data) {
                        var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        if(parseInt(value) >= 1000){
                                return '₩' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                } else {
                                return '₩' + value;
                                }
                    }
            } // end callbacks:
        }, //end tooltips                
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true,
                        callback: function(value, index, values) {
                            if(parseInt(value) >= 1000){
                               return '₩' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            } else {
                               return '₩' + value;
                            }
                       }                            
                    }
                }]
            }
        },
        options3: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
            callbacks: {
                    label: function(tooltipItem, data) {
                        var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        if(parseInt(value) >= 1000){
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '건';
                                } else {
                                return value + '건';
                                }
                    }
            } 
        },                
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true,
                        callback: function(value, index, values) {
                            if(parseInt(value) >= 1000){
                               return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '건';
                            } else {
                               return value + '건';
                            }
                       }                            
                    }
                }]
            }
        },
        options4: {
            borderWidth: "10px",
            hoverBackgroundColor: "red",
            hoverBorderWidth: "10px",
            legend: { display: true, position: 'right', },
            tooltips: {
            callbacks: {
                    label: function(tooltipItem, data) {
                    let value = data.datasets[0].data[tooltipItem.index];
                    let dataset = data.datasets[tooltipItem.datasetIndex];
                    let total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                        return previousValue + currentValue;
                    });
                    let currentValue = dataset.data[tooltipItem.index];
                    let precentage = Math.floor(((currentValue/total) * 100)+0.5);
                        if(parseInt(value) >= 1000){
                                return `${data['labels'][tooltipItem.index]} (${precentage}%) ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원`
                                } else {
                                return `${data['labels'][tooltipItem.index]} (${precentage}%) ${value}원`
                                }
                    }
            } 
        }, 
        },
        options2: {
            borderWidth: "10px",
            hoverBackgroundColor: "red",
            hoverBorderWidth: "10px",
            legend: { display: true, position: 'right', },
            tooltips: {
            callbacks: {
                    label: function(tooltipItem, data) {
                    let value = data.datasets[0].data[tooltipItem.index];
                    let dataset = data.datasets[tooltipItem.datasetIndex];
                    let total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                        return previousValue + currentValue;
                    });
                    let currentValue = dataset.data[tooltipItem.index];
                    let precentage = Math.floor(((currentValue/total) * 100)+0.5);
                        if(parseInt(value) >= 1000){
                                return `${data['labels'][tooltipItem.index]} (${precentage}%) ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}건`
                                } else {
                                return `${data['labels'][tooltipItem.index]} (${precentage}%) ${value}건`
                                }
                    }
            } 
        }, 
        },
        datacollection: {},
        items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
        search:'',
        today: moment().format('YYYY-MM-DD'),
        subDate:'',
        tempInfo:[],
        tempInfoMonth:[],
        app_ad:'front',
        days:1,
        menu: false,
        menu2:false,
        date:moment().subtract(3,'M').format('yyyy-MM-DD'),
        date2:moment().format('yyyy-MM-DD'),
        targetUser:'USER_ID',
        isMailAll:false,
        loadingData:false,        
        mailTitle:'',
        mailMessage:'',
        statisticsData:[],
        start_date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        end_date:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        itemInfoList:[
            {
                name:'보석',
                value:'item_type_1',
            },
            {
                name:'골드',
                value:'item_type_2',
            }   
        ],
        viewCount:'노출수',
        clickCount:'클릭수',
        downCount:'다운수',
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록
        /*
        headers: [            
            { text: '게임명', value: 'appName', sortable: false },
            { text: '노출수', value: 'viewCount', sortable: true, width:200  },
            { text: '클릭수', value: 'clickCount', sortable: true, width:200 },
            { text: '다운수', value: 'downCount', sortable: true, width:200 },
            { text: '클릭률%', value: 'clickProb', sortable: true, width:150 },
            { text: '클릭다운률%', value: 'clickDownProb', sortable: true, width:150 },
            { text: '노출다운률%', value: 'viewDownProb', sortable: true, width:150 },
        ],
        */
        event_history_all:[           
        ]
    }),

    created()
    {
     this.getBillingProjectList()
     console.log('프로젝트 리스트',this.billingProjectList)
     this.dateCaculate()
    },

    methods:{
        ...mapActions([
            'GET_LOG_TODAY',
            'GET_LOG',
            // 통계를 보여줄 데이터를 가져온다.
            'GET_PROJECT_BILLING_STATISTICS_DATA',
            // 프로젝트 명단을 가져온다.( 기존의 쿼리를 사용 가능할 듯 하다.)
            'GET_BILLING_PROJECTS'
        ]),
        submit(){
            console.log('결제 데이터 가져오기 실행됨')
            // 데이터를 체우기 전에 비워준다. 차트 컨포넌트에서 에러가 나기 때문에 이러한 데이터를 넣어준다.
            this.projectBillingStatisticsData = {'day':[],'month':[],'others':[],'pieAndroid':[],'pieIos':[]}
            this.request = true
            this.getProjectBillingStatisticsData()
        },
        async getBillingProjectList () {
            this.arr = Object.values(await this.GET_BILLING_PROJECTS())
            this.billingProjectList = this.arr
            console.log(this.billingProjectList)
        },
        async getProjectBillingStatisticsData () {
            const selected_project = this.selectedProject
            const temp_info = this.tempInfo
            const temp_info_month = this.tempInfoMonth
            this.projectBillingStatisticsData = await this.GET_PROJECT_BILLING_STATISTICS_DATA({selected_project,temp_info,temp_info_month})
            console.log(this.projectBillingStatisticsData)
            // others
            this.androidTotalSumCost ='₩' + this.projectBillingStatisticsData.others.androidTotalSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.iosTotalSumCost = '₩' +this.projectBillingStatisticsData.others.iosTotalSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.totalSumCost = '₩' +this.projectBillingStatisticsData.others.totalSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.androidTotalSumCount = this.projectBillingStatisticsData.others.androidTotalSumCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.iosTotalSumCount = this.projectBillingStatisticsData.others.iosTotalSumCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.totalSumCount = this.projectBillingStatisticsData.others.totalSumCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.androidKorSumCost = '₩' +this.projectBillingStatisticsData.others.androidKorSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.androidEnSumCost= '₩' +this.projectBillingStatisticsData.others.androidEnSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.androidChSumCost= '₩' +this.projectBillingStatisticsData.others.androidChSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.androidTwSumCost= '₩' +this.projectBillingStatisticsData.others.androidTwSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.androidJpSumCost= '₩' +this.projectBillingStatisticsData.others.androidJpSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.iosKorSumCost= '₩' +this.projectBillingStatisticsData.others.iosKorSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.iosEnSumCost= '₩' +this.projectBillingStatisticsData.others.iosEnSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.iosChSumCost= '₩' +this.projectBillingStatisticsData.others.iosChSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.iosTwSumCost= '₩' +this.projectBillingStatisticsData.others.iosTwSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.iosJpSumCost= '₩' +this.projectBillingStatisticsData.others.iosJpSumCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            // line
            // 배열 map 함수를 사용하여서 DATE요소만을 반환한 새로운 배열을 만들어서 대입시켜준다

        },
        dateCaculate () {
                console.log('date watch 실행됨')
                if(this.date != ''){
                this.tempInfo = []
                this.subDate = moment(this.date)
                while ( this.subDate <= moment(this.date2)){
                    this.tempInfo.push( this.subDate.format('YYYY-MM-DD'))
                    this.subDate = this.subDate.add(1,'days')
                }
                // 월의 배열을 만들어준다.
                this.tempInfoMonth = Array.from(new Set(this.tempInfo.map((value,index,array)=> {
                    return value.substr(0,7)
                })))

            }
            this.subDate = ''
        },
    },
    computed: {
        dataFlag () {
            return this.projectBillingStatisticsData.day[0]?'dataEx':this.request?'underRequest':'noRequest'
        },
        osForWatch () {
            return store.state.selected_ad_os
        },
        langeageForWatch () {
            return store.state.selected_ad_language
        },
        // 받아온 배열상에서 각 해당하는 내용들을 다 더해서 반환해줘야 한다.
        // 배열 메서드 reduce 를 사용한다.
        totalViewCount () {
            return this.statisticsData[0]?`(${this.statisticsData.reduce((p, c, i, a) => {
                return p + c.viewCount
            }, 0)})`:''
        },
        totalClickCount () {
            return this.statisticsData[0]?`(${this.statisticsData.reduce((p, c, i, a) => {
                return p + c.clickCount
            }, 0)})`:''
        },
        totalDownCount () {
            return this.statisticsData[0]?`(${this.statisticsData.reduce((p, c, i, a) => {
                return p + c.downCount
            }, 0)})`:''
        },
        chartdataDayCost () {
            return {
                labels: this.projectBillingStatisticsData.day.map((value,index,array)=> { return value.DATE }),
                datasets: [
                    {
                    label: '전체',
                    borderColor: '#ff6666',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.day.map((value,index,array)=> { return value.totalDaySumCost })
                    },
                    {
                    label: '안드로이드',
                    borderColor: '#66ff66',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.day.map((value,index,array)=> { return value.androidDaySumCost })
                    },
                    {
                    label: 'ios',
                    borderColor: '#66b2ff',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.day.map((value,index,array)=> { return value.iosDaySumCost })
                    },
                ]
            }
        },
        chartdataDayCount () {
            return {
                labels: this.projectBillingStatisticsData.day.map((value,index,array)=> { return value.DATE }),
                datasets: [
                    {
                    label: '전체',
                    borderColor: '#ff6666',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.day.map((value,index,array)=> { return value.totalDaySumCount })
                    },
                    {
                    label: '안드로이드',
                    borderColor: '#66ff66',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.day.map((value,index,array)=> { return value.androidDaySumCount })
                    },
                    {
                    label: 'ios',
                    borderColor: '#66b2ff',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.day.map((value,index,array)=> { return value.iosDaySumCount })
                    },
                ]
            }
        },
        chartdataMonCost () {
            return {
                labels: this.projectBillingStatisticsData.month.map((value,index,array)=> { return value.MONTH }),
                datasets: [
                    {
                    label: '전체',
                    borderColor: '#ff6666',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.month.map((value,index,array)=> { return value.totalMonthSumCost })
                    },
                    {
                    label: '안드로이드',
                    borderColor: '#66ff66',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.month.map((value,index,array)=> { return value.androidMonthSumCost })
                    },
                    {
                    label: 'ios',
                    borderColor: '#66b2ff',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.month.map((value,index,array)=> { return value.iosMonthSumCost })
                    },
                ]
            }
        },
        chartdataMonCount () {
            return {
                labels: this.projectBillingStatisticsData.month.map((value,index,array)=> { return value.MONTH }),
                datasets: [
                    {
                    label: '전체',
                    borderColor: '#ff6666',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.month.map((value,index,array)=> { return value.totalMonthSumCount })
                    },
                    {
                    label: '안드로이드',
                    borderColor: '#66ff66',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.month.map((value,index,array)=> { return value.androidMonthSumCount })
                    },
                    {
                    label: 'ios',
                    borderColor: '#66b2ff',
                    fill: false,
                    tension: 0,
                    data: this.projectBillingStatisticsData.month.map((value,index,array)=> { return value.iosMonthSumCount })
                    },
                ]
            }
        },
        androidPie () {
            return {
            hoverBackgroundColor: "red",
            hoverBorderWidth: 10,
            labels: this.projectBillingStatisticsData.pieAndroid.map((value,index,array)=> { return value.product_name }),
            datasets: [
            {
                label: "android",
                backgroundColor: ["#93DAFF", "#32F1FF", "#1E90FF", "#96A5FF", "#3DFF92", "#80E12A", "#20B2AA", "#FFB6C1","#FF5675", "#FF82FF", "#FF1493", "#CD1039", "#FAEB78", "#FFA500", "#FFA374", "#D2691E", "#9932CC", "#942894", "#828282", "#8B4513", "#FFA98F", "#54BD54", "#BCFF66", "#5A5AFF"],
                data:  this.projectBillingStatisticsData.pieAndroid.map((value,index,array)=> { return value.bill_count })
            }
            ]
            }
        },
        androidPie_cost () {
            return {
            hoverBackgroundColor: "red",
            hoverBorderWidth: 14,
            labels: this.projectBillingStatisticsData.pieAndroid.map((value,index,array)=> { return value.product_name }),
            datasets: [
            {
                label: "android",
                backgroundColor: ["#93DAFF", "#32F1FF", "#1E90FF", "#96A5FF", "#3DFF92", "#80E12A", "#20B2AA", "#FFB6C1","#FF5675", "#FF82FF", "#FF1493", "#CD1039", "#FAEB78", "#FFA500", "#FFA374", "#D2691E", "#9932CC", "#942894", "#828282", "#8B4513", "#FFA98F", "#54BD54", "#BCFF66", "#5A5AFF"],
                data:  this.projectBillingStatisticsData.pieAndroid.map((value,index,array)=> { return value.bill_cost })
            }
            ]
            }
        },
        iosPie () {
            return {
            hoverBackgroundColor: "red",
            hoverBorderWidth: 10,
            labels: this.projectBillingStatisticsData.pieIos.map((value,index,array)=> { return value.product_name }),
            datasets: [
            {
                label: "ios",
                backgroundColor: ["#93DAFF", "#32F1FF", "#1E90FF", "#96A5FF", "#3DFF92", "#80E12A", "#20B2AA", "#FFB6C1","#FF5675", "#FF82FF", "#FF1493", "#CD1039", "#FAEB78", "#FFA500", "#FFA374", "#D2691E", "#9932CC", "#942894", "#828282", "#8B4513", "#FFA98F", "#54BD54", "#BCFF66", "#5A5AFF"],
                data: this.projectBillingStatisticsData.pieIos.map((value,index,array)=> { return value.bill_count })
            }
            ]
            }
        },
    },
    watch :{
        date: function() {
                console.log('date watch 실행됨')
                if(this.date != ''){
                this.tempInfo = []
                this.subDate = moment(this.date)
                console.log(this.subDate)
                console.log(moment(this.date2))
                console.log(this.subDate <= moment(this.date2))
                while ( this.subDate <= moment(this.date2)){
                    console.log(this.subDate)
                    this.tempInfo.push( this.subDate.format('YYYY-MM-DD'))
                    this.subDate = this.subDate.add(1,'days')
                }
                // 월의 배열을 만들어준다.
                this.tempInfoMonth = Array.from(new Set(this.tempInfo.map((value,index,array)=> {
                    return value.substr(0,7)
                })))
                // 여기서 만들어진 배열은 그래프의 X축으로 들어가게 된다.
            }
            this.subDate = ''
        },
        date2: function() {
            console.log('date2 watch 실행됨')
            if(this.date2 != ''){
                this.tempInfo = []
                this.subDate = moment(this.date)
                while ( this.subDate <= moment(this.date2)){
                    console.log(this.subDate)
                    this.tempInfo.push( this.subDate.format('YYYY-MM-DD'))
                    this.subDate = this.subDate.add(1,'days')
                }
                // 월의 배열을 만들어준다.
                this.tempInfoMonth = Array.from(new Set(this.tempInfo.map((value,index,array)=> {
                    return value.substr(0,7)
                })))
                // 여기서 만들어진 배열은 그래프의 X축으로 들어가게 된다.
            }
            this.subDate = ''
        },
        projectBillingStatisticsData: function() {
            if(this.projectBillingStatisticsData.day[0]){
                this.request = false
            }
        },
    },
    mounted () {
    },
};
</script>
<style>
</style>